import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

import { InvitePartnerForm } from '../../components/invitePartner/InvitePartnerForm'
import { InviteKazooPlanner } from '../../components/invitePartner/InviteKazooPlanner'
import { InvitePendingView } from '../../components/invitePartner/InvitePendingView'
import { InviteAcceptedView } from '../../components/invitePartner/InviteAcceptedView'
import { getKazooMembers, deletePartnerFromKazoo } from '../../features/kazooEventSlice'
import LeaveModal from '../../components/atoms/modal/LeaveConfirmationModal'
import { useTutorial } from '../../context/TutorialContext'
import { useTutorialStatus } from '../../hooks/useTutorialStatus'

import styles from './InvitePartnerPage.module.scss'

export const InvitePartner = () => {
	const dispatch = useDispatch()
	const { kazooId } = useParams()
	const bride = useSelector((state) => state.kazooEvent.kazooMembers.bride)
	const groom = useSelector((state) => state.kazooEvent.kazooMembers.groom)
	const role = useSelector((state) => state.kazooEvent.role)

	const [modal, setModal] = useState('')
	const openModal = (modal) => setModal(modal)
	const closeModal = () => setModal('')

	// Tutorial hooks
	const { hasSeenTutorial, isLoading } = useTutorialStatus('invite-partner')
	const { startTutorial, isTutorialActive } = useTutorial()

	// Tutorial effect
	useEffect(() => {
		if (!isLoading && !hasSeenTutorial && !isTutorialActive()) {
			const timer = setTimeout(() => {
				startTutorial('invite-partner')
			}, 1000)
			return () => clearTimeout(timer)
		}
	}, [isLoading, hasSeenTutorial, isTutorialActive, startTutorial])

	const handleRemovePartner = async () => {
		let email
		if (bride?.status === 'sent') {
			email = bride?.email
		} else if (groom?.status === 'sent') {
			email = groom?.email
		} else if (role === 'bride' && groom?._id) {
			email = groom?.email
		} else if (role === 'groom' && bride?._id) {
			email = bride?.email
		}

		if (email) {
			dispatch(deletePartnerFromKazoo({ kazooId, email })).then((result) => {
				if (result.payload?.success) {
					dispatch(getKazooMembers(kazooId))
				}
			})
		}
		closeModal()
	}

	const renderScreens = () => {
		// For Kazoo Planners - always show two-column design
		if (role === 'kazoo-planner') {
			return <InviteKazooPlanner />
		}
		
		// For regular users (Bride/Groom) - show original single-partner design
		if (
			(!bride?._id && !bride?.status && !bride?.email) ||
			(!groom?._id && !groom?.status && !groom?.email)
		) {
			return <InvitePartnerForm />
		}
		if (bride?.status || groom?.status) {
			const invited =
				bride?.status === 'sent'
					? { email: bride.email, status: bride.status }
					: { email: groom.email, status: groom.status }

			return (
				<InvitePendingView
					email={invited.email}
					status={invited.status}
					openModal={openModal}
				/>
			)
		}
		const accepted =
			bride?._id && !bride?.status
				? { role: 'Bride', email: bride.email }
				: groom?._id && !groom?.status
					? { role: 'Groom', email: groom.email }
					: null

		if (accepted) {
			return <InviteAcceptedView openModal={openModal} />
		}
	}

	useEffect(() => {
		dispatch(getKazooMembers(kazooId))
	}, [dispatch, kazooId])

	return (
		<>
			<div className={styles.pageHeader}>
				<Typography component="h1">Invite Partner</Typography>
				{/* <div className={styles.right}>
					<div className={styles.date}>
						<img src="/images/calendar_line.svg" alt="" />
						<span>12 Apr 2025</span>
					</div>
				</div> */}
			</div>
			<div className={styles.pageMain}>
				<Box className={styles.card}>
					{renderScreens()}
					<img
						src="/images/mail.svg"
						alt="invite-partner"
						className={styles.inviteImg}
					/>
				</Box>
			</div>
			<LeaveModal
				open={modal === 'removePartner'}
				onClose={closeModal}
				onLeave={handleRemovePartner}
				header="Remove Partner"
				subHeader='Are you sure you want to remove your partner?'
				confirmBtnTxt="Confirm"
			/>
		</>
	)
}
